<template>
  <div class="swiperconall">
    <div
      class="container-swipers"
      v-if="type == 1 && bannerphoto.length"
    >
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in bannerphoto" :key="index">
          <img
            class="swiper-img"
            :src="server + item.cover"
          />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="container-swiper" v-if="type == 2 && bannerphoto.length">
      <swiper ref="mySwiper" :options="swiperOption2">
        <swiper-slide v-for="(item, index) in bannerphoto" :key="index">
          <img class="swiper-img" :src="server + item.cover" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev active" slot="button-prev" @click="pre()"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>
    <div class="container-swiper3" v-if="type == 3 && bannerphoto.length">
      <swiper ref="mySwiper" :options="swiperOption3">
        <swiper-slide v-for="(item, index) in bannerphoto" :key="index">
          <img class="swiper-img" :src="server + item.cover" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>
<script>
export default {
  name: "Slider",
  data() {
    return {
      server: "http://www.cctpress.com/file/",
      swiperheight: 0, //
      swiperimgheight: 0,
      swiperOptions: {
        //swiper属性
        direction: "horizontal" /*横向滑动*/,
        loop: true,
        autoplay: {
          disableOnInteraction: true,
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        observeParents: false, //必须加入
        observer: true, //必须加入
      },
      swiperOption2: {
        effect: "fade",
        direction: "horizontal" /*横向滑动*/,
        loop: true,
        autoplay: {
          disableOnInteraction: true,
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observeParents: false, //必须加入
        observer: true, //必须加入
      },
      swiperOption3: {
        //swiper属性
        direction: "horizontal" /*横向滑动*/,
        loop: true,
        autoplay: {
          disableOnInteraction: true,
          delay: 3000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        observeParents: false, //必须加入
        observer: true, //必须加入
      },
    };
  },
  props: ["bannerphoto", "type"],
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  mounted() {
    // //获取屏幕高度
    // let h = document.documentElement.clientHeight || document.body.clientHeight;
    // this.swiperheight = h - 200 + "px";
    // this.swiperimgheight = h - 210 + "px";
  },
};
</script>

<style lang="scss">
.container-swipers {
  width: 100%;
  height: 700px;
  overflow: hidden;
  position: relative;
}

.swiper-slide img {
  width: 100%;
  height:666px;
}
.swiper-pagination {
  height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.swiper-pagination .swiper-pagination-bullet {
  width: 34px !important;
  height: 8px !important;
  background: #ffffff !important;
  opacity: 0.4 !important;
  border-radius: 4px !important;
  margin: 4px !important;
  display: block !important;
}
.swiper-pagination .swiper-pagination-bullet-active {
  display: block !important;
  width: 57px !important;
  height: 8px !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  opacity: 1 !important;
}

.container-swiper {
  width: 1000px;
  height: 345px;
  position: relative;
  .swiper-container {
    width: 100%;
    height: 340px;
    .swiper-wrapper {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .swiper-pagination {
      height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      // position: absolute;
      // bottom: 2px;
      .swiper-pagination-bullet {
        width: 30px !important;
        height: 5px !important;
        background: #999999;
        opacity: 0.8 !important;
        border-radius: 1px !important;
        margin: 4px !important;
        display: block !important;
      }
      .swiper-pagination-bullet-active {
        display: block !important;
        width: 30px !important;
        height: 5px !important;
        background: #ffffff;
        border-radius: 1px !important;
        opacity: 1 !important;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      width: 32px;
      height: 60px;
      color: #fff;
      background: #5e5f5e;
      opacity: 0.5;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
    .swiper-button-prev:after,
    .swiper-button-next:after {
      color-size: 22px;
      background: rbg(2, 195, 154) !important;
    }
  }
}

.container-swiper3 {
  width: 1170px;
  height: 255px;
  position: relative;
  .swiper-container {
    width: 100%;
    height: 250px;
    .swiper-wrapper {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .swiper-pagination {
      height: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
